module.exports = __webpack_public_path__ + "media/assets/images/smart_working/4-bg-de6a98a13c1a7c6383088fa125d3e25b.jpg";